import axios from "axios";
import { useEffect, useState } from "react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const KEY = "vynl_interest_clicked";

// Tiny module-level store so multiple button instances (hero + founding) stay in sync.
let state = { total: 0, clicked: false, ready: false };
const subs = new Set();
let initStarted = false;

const notify = () => subs.forEach((fn) => fn(state));
const set = (patch) => {
  state = { ...state, ...patch };
  notify();
};

async function initInterest() {
  if (initStarted) return;
  initStarted = true;
  let clicked = false;
  try {
    clicked = localStorage.getItem(KEY) === "1";
  } catch (e) {}
  set({ clicked });
  try {
    const { data } = await axios.get(`${API}/interest`);
    set({ total: data.total ?? 0, ready: true });
  } catch (e) {
    set({ ready: true });
  }
}

export async function likeInterest() {
  if (state.clicked) return { counted: false, already: true };
  try {
    const { data } = await axios.post(`${API}/interest`);
    try {
      localStorage.setItem(KEY, "1");
    } catch (e) {}
    set({ clicked: true, total: data.total ?? state.total });
    return { counted: !!data.counted, already: false };
  } catch (e) {
    return { counted: false, already: false, error: true };
  }
}

export function useInterest() {
  const [s, setS] = useState(state);
  useEffect(() => {
    subs.add(setS);
    setS(state);
    initInterest();
    return () => subs.delete(setS);
  }, []);
  return s;
}
